import { PaldockPage, PaldockPageProps } from "components/UI/PaldockPage/PaldockPage.tsx";

export type AccountPageProps = PaldockPageProps;

export const AccountPage = (props: AccountPageProps) => {
    return <PaldockPage {...props} />;
};
